export default __webpack_public_path__ + "static/media/TemplateBuildAndRelease.3d095c64.yml";